import { AutoTextarea, Field, ListEditor } from "./shared";
import { Stethoscope, User } from "lucide-react";

export const TwoColForm = ({ data, onChange, specs, config }) => {
  const blocks = specs[config.blocks];
  const setBlock = (k, patch) => onChange({ ...data, blocks: { ...data.blocks, [k]: { ...(data.blocks?.[k] || {}), ...patch } } });
  return (
    <div className="space-y-4" data-testid="two-col-form">
      <div className="rounded-xl border overflow-hidden">
        <div className="grid grid-cols-[180px_1fr_1fr] bg-muted/40 text-xs font-semibold border-b">
          <div className="px-3 py-2">Étape</div>
          <div className="px-3 py-2 flex items-center gap-1.5"><Stethoscope className="w-3.5 h-3.5" /> Formulation du thérapeute</div>
          <div className="px-3 py-2 flex items-center gap-1.5"><User className="w-3.5 h-3.5" /> Dans les mots du patient</div>
        </div>
        {blocks.map((b, i) => {
          const v = data.blocks?.[b.key] || { therapist: "", patient: "" };
          return (
            <div key={b.key} className={`grid grid-cols-[180px_1fr_1fr] border-b last:border-b-0 ${i % 2 ? "bg-muted/10" : ""}`} data-testid={`stabc-row-${b.key}`}>
              <div className="px-3 py-2">
                <div className="text-sm font-medium">{b.label}</div>
                <div className="text-[11px] text-muted-foreground">{b.hint}</div>
              </div>
              <div className="p-2"><AutoTextarea value={v.therapist} onChange={(x) => setBlock(b.key, { therapist: x })} rows={3} testId={`stabc-${b.key}-therapist`} /></div>
              <div className="p-2"><AutoTextarea value={v.patient} onChange={(x) => setBlock(b.key, { patient: x })} rows={3} className="italic" testId={`stabc-${b.key}-patient`} /></div>
            </div>
          );
        })}
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        <Field label="Hypothèse de la boucle schéma → mode → coping"><AutoTextarea value={data.hypothesis} onChange={(v) => onChange({ ...data, hypothesis: v })} rows={4} testId="stabc-hypothesis" /></Field>
        <Field label="Boucle du travail personnel" hint="Une étape par ligne"><ListEditor value={data.homework_loop} onChange={(v) => onChange({ ...data, homework_loop: v })} rows={4} testId="stabc-homework-loop" /></Field>
      </div>
    </div>
  );
};
